import type { CalendarType } from "@/lib/calendars";

export type LanguageKey = "en" | "de" | "fr" | "ckb" | "kmr" | "fa";
export type Currency = "USD" | "EUR" | "IQD" | "TRY" | "IRR";

export interface LanguageConfig {
  /** The language's own name (endonym), so each option reads right whatever the current UI language. */
  label: string;
  locale: string;
  direction: "ltr" | "rtl";
  /** Calendar dates are shown and picked in (same split as the dashboard's dateFormat.type). */
  calendar: CalendarType;
  dateFormat: string;
  timezone: string;
  currency: string;
}

export const languages: Record<LanguageKey, LanguageConfig> = {
  en: {
    label: "English",
    locale: "en-US",
    direction: "ltr",
    calendar: "gregorian",
    dateFormat: "MM/DD/YYYY",
    timezone: "UTC",
    currency: "USD",
  },
  de: {
    label: "Deutsch",
    locale: "de-DE",
    direction: "ltr",
    calendar: "gregorian",
    dateFormat: "DD.MM.YYYY",
    timezone: "Europe/Berlin",
    currency: "EUR",
  },
  fr: {
    label: "Français",
    locale: "fr-FR",
    direction: "ltr",
    calendar: "gregorian",
    dateFormat: "DD/MM/YYYY",
    timezone: "Europe/Paris",
    currency: "EUR",
  },
  ckb: {
    label: "کوردی (سۆرانی)",
    locale: "ckb-IQ",
    direction: "rtl",
    calendar: "kurdish",
    dateFormat: "YYYY/MM/DD",
    timezone: "Asia/Baghdad",
    currency: "IQD",
  },
  kmr: {
    label: "Kurdî (Kurmancî)",
    locale: "kmr-TR",
    direction: "ltr",
    calendar: "kurdish",
    dateFormat: "YYYY-MM-DD",
    timezone: "Europe/Istanbul",
    currency: "TRY",
  },
  fa: {
    locale: "fa-IR",
    label: "فارسی",
    direction: "rtl",
    calendar: "jalali",
    dateFormat: "YYYY/MM/DD",
    timezone: "Asia/Tehran",
    currency: "IRR",
  },
};

export interface LocalizationContextValue {
  language: LanguageKey;
  config: LanguageConfig;
  setLanguage: (lang: LanguageKey) => void;
}
